import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";
import { formatText } from "bernie-l10n";
import { Logger } from "bernie-logger";
import { pillsConfig, flightClassId, starRatingId, tripLengthId } from "components/flexComponents/Packages/config";

export class PackagePillStore extends Store {
  @observable
  public tripLengthName: string;

  @observable
  public starRatingName: string;

  @observable
  public flightClassName: string;

  @observable
  public tripLengthToggleState: boolean;

  @observable
  public starRatingToggleState: boolean;

  @observable
  public flightClassToggleState: boolean;

  public static DEFAULTS = {
    tripLengthName: "",
    starRatingName: "",
    flightClassName: "",
    tripLengthToggleState: false,
    starRatingToggleState: false,
    flightClassToggleState: false,
  };

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
    this.reset();
  }

  @action
  public reset() {
    this.resetPillNames();
    this.resetToggles();
  }

  @action
  public updatePill(pillId: string, newPillName: string) {
    switch (pillId) {
      case tripLengthId:
        this.tripLengthName = newPillName;
        this.tripLengthToggleState = true;
        break;
      case starRatingId:
        this.starRatingName = newPillName;
        this.starRatingToggleState = true;
        break;
      case flightClassId:
        this.flightClassName = newPillName;
        this.flightClassToggleState = true;
        break;
      default:
        break;
    }
  }

  public getPillName(pillId: string): string {
    switch (pillId) {
      case tripLengthId:
        return this.tripLengthName;
      case starRatingId:
        return this.starRatingName;
      case flightClassId:
        return this.flightClassName;
      default:
        return "";
    }
  }

  public getPillToggleState(pillId: string): boolean {
    switch (pillId) {
      case tripLengthId:
        return this.tripLengthToggleState;
      case starRatingId:
        return this.starRatingToggleState;
      case flightClassId:
        return this.flightClassToggleState;
      default:
        return false;
    }
  }

  private resetToggles() {
    this.tripLengthToggleState = false;
    this.starRatingToggleState = false;
    this.flightClassToggleState = false;
  }

  private resetPillNames() {
    pillsConfig.map((pill) => {
      switch (pill.pillId) {
        case tripLengthId:
          this.tripLengthName = formatText(pill.name);
          break;
        case starRatingId:
          this.starRatingName = formatText(pill.name);
          break;
        case flightClassId:
          this.flightClassName = formatText(pill.name);
          break;
      }
    });
  }
}
